var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gradient-wrapper",style:({
    padding: _vm.thickness,
    backgroundColor: _vm.colorA,
    backgroundImage: 'linear-gradient(' + _vm.colorA + ',' + _vm.colorB + ') '
  }),on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{style:({ width: _vm.size, height: _vm.size }),attrs:{"id":"maincircle"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }